import EfImg from '@elem/ui/ef-img';
import css from './index.module.scss';
import { useLang } from '@/i18n';
import EfSpec from '@elem/ui/ef-spec';
import { Swiper, SwiperSlide } from 'swiper/react';
import { useEffect, useState } from 'react';

interface ItemType {
    img: string;
    title: string;
    desc: string;
}
export default function I() {
    const { t } = useLang('bkw');
    const [gap, setGap] = useState<number>(16);
    const items: ItemType[] = [
        {
            img: 'https://websiteoss.ecoflow.com/upload/image/1738897435761/8_1.jpg',
            title: t('I_item1_title'),
            desc: t('I_item1_desc'),
        },
        {
            img: 'https://websiteoss.ecoflow.com/upload/image/1738897435934/8_2.jpg',
            title: t('I_item2_title'),
            desc: t('I_item2_desc'),
        },
    ];

    useEffect(() => {
        if (typeof window !== 'undefined') {
            setGap(window.innerWidth > 1440 ? 24 : 16);
        }
    }, []);

    return (
        <div id="bkw-I" className={`bkw-I bkw-box ${css['bkw-I']}`}>
            <EfSpec />
            <Swiper className="items" spaceBetween={gap} slidesPerView={'auto'} initialSlide={0}>
                {items?.map((item: ItemType, k: number) => (
                    <SwiperSlide className={`item item-${k + 1}`} key={k}>
                        <div className="item-img">
                            <EfImg pc={item.img} />
                        </div>
                        <div className="item-info">
                            <p className="item-title">{item.title}</p>
                            <p className="item-desc">{item.desc}</p>
                        </div>
                    </SwiperSlide>
                ))}
            </Swiper>
        </div>
    );
}
